import React from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { actions, addCustomerModalState } from '../../state/src/add-customer-modal-slice';

export const useAddCustomerModal = () => {
  const dispatch = useDispatch();
  const state = useSelector(addCustomerModalState, shallowEqual);

  const openAddCustomerModal = (payload = {}) => {
    if (state.isAddCustomerModalOpen === false) {
      dispatch(actions.openAddCustomerModal(payload));
    } else {
      return {
        type: 'NOOP',
      };
    }
  };

  const closeAddCustomerModal = React.useCallback(() => {
    dispatch(actions.closeAddCustomerModal());
  }, [dispatch]);

  return {
    ...state,
    openAddCustomerModal,
    closeAddCustomerModal,
  };
};
